import { BugBountyStatusValues } from '@atlassian/mpac-types';
import { AtlassianProductHostingType } from '@atlassian/mpac-types/graphql-gateway-types';
import { log } from '@atlassian/mpac-utils';
export const toBugBountyHosting = hosting => {
  if (hosting === AtlassianProductHostingType.Cloud) {
    return 'cloud';
  } else if (hosting === AtlassianProductHostingType.DataCenter) {
    return 'dataCenter';
  } else if (hosting === AtlassianProductHostingType.Server) {
    return 'server';
  }
};
export const isBugBountyStatusApproved = (bb, hosting) => {
  if (hosting === AtlassianProductHostingType.Cloud) {
    var _bb$cloud, _bb$cloud$status;
    return (bb === null || bb === void 0 ? void 0 : (_bb$cloud = bb.cloud) === null || _bb$cloud === void 0 ? void 0 : (_bb$cloud$status = _bb$cloud.status) === null || _bb$cloud$status === void 0 ? void 0 : _bb$cloud$status.toLowerCase()) === BugBountyStatusValues.Approved;
  } else if (hosting === AtlassianProductHostingType.DataCenter) {
    var _bb$dataCenter, _bb$dataCenter$status;
    return (bb === null || bb === void 0 ? void 0 : (_bb$dataCenter = bb.dataCenter) === null || _bb$dataCenter === void 0 ? void 0 : (_bb$dataCenter$status = _bb$dataCenter.status) === null || _bb$dataCenter$status === void 0 ? void 0 : _bb$dataCenter$status.toLowerCase()) === BugBountyStatusValues.Approved;
  } else if (hosting === AtlassianProductHostingType.Server) {
    var _bb$server, _bb$server$status;
    return (bb === null || bb === void 0 ? void 0 : (_bb$server = bb.server) === null || _bb$server === void 0 ? void 0 : (_bb$server$status = _bb$server.status) === null || _bb$server$status === void 0 ? void 0 : _bb$server$status.toLowerCase()) === BugBountyStatusValues.Approved;
  }
  return false;
};
export const isBugBountyParticipant = (hostingType, bugBountyParticipant) => {
  const bugBountyHosting = toBugBountyHosting(hostingType);
  if (!bugBountyHosting) {
    log.error("isBugBountyParticipant", "Error in mapping hosting value for ".concat(hostingType));
    return false;
  }
  return isBugBountyStatusApproved(bugBountyParticipant, hostingType);
};